<template>
  <div class="about-title">
    <span class="label">{{label}}</span>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    type: {
      type: String,
      default: 'dark'
    }
  }
}
</script>

<style lang="less" scoped>
  .about-title{
    font-size: 1.146vw;
    line-height: 3.229vw;
    padding: 1.042vw 0 0;
    display: flex;
    justify-content: space-between;
    .label{
      position: relative;
      &::after{
        content: '';
        width: 100%;
        height: 0.26vw;
        border-radius: 0.26vw;
        position: absolute;
        bottom: 0px;
        left: 0px;
        background-color: #E04A26;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/aboutTitle.vue